import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import RaiContext from "./config/RaiContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RaiContext>
        <App />
      </RaiContext>
    </BrowserRouter>
  </React.StrictMode>
);
